// Module
var code = "<iframe class=\"CollectJSGooglePayIFrame\" src=\"https://collectcheckout.com\" height=\"45px\" allowpaymentrequest></iframe> ";
// Exports
module.exports = code;